import { floorNumber } from "./number";

export const timeLeft = (
	timestamp: number,
	inSeconds: boolean = false,
): number => Math.trunc((timestamp - Date.now()) / (inSeconds ? 1e3 : 1));

export const formatTimeString = (time: number): string => {
	const days = floorNumber(time / 86400);
	const hours = floorNumber((time % 86400) / 3600);
	const minutes = floorNumber((time % 3600) / 60);
	const seconds = floorNumber(time % 60);

	const parts = [];

	if (days) {
		parts.push(`${days}d`);
		if (hours) {
			parts.push(`${hours < 10 ? "0" : ""}${hours}h`);
		} else if (minutes) {
			parts.push(`${minutes < 10 ? "0" : ""}${minutes}m`);
		}
	} else if (hours) {
		parts.push(`${hours < 10 ? "0" : ""}${hours}h`);
		if (minutes) {
			parts.push(`${minutes < 10 ? "0" : ""}${minutes}m`);
		} else if (seconds) {
			parts.push(`${seconds < 10 ? "0" : ""}${seconds}s`);
		}
	} else if (minutes) {
		parts.push(`${minutes}m`);
		if (seconds) {
			parts.push(`${seconds < 10 ? "0" : ""}${seconds}s`);
		}
	} else if (seconds) {
		parts.push(`${seconds}s`);
	}

	return parts.join(" ");
};
